import { render, staticRenderFns } from "./ReadOnlyCartBoxItem.vue?vue&type=template&id=8fdc2856&"
import script from "./ReadOnlyCartBoxItem.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyCartBoxItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports